import React, { useRef } from "react"
import * as styles from "./EventOurServices.module.scss"
import { GatsbyImage } from "gatsby-plugin-image"

const EventOurServices = ({ data }) => {
  const { title, imageArray } = data
  const sliderRef = useRef(null)

  const scroll = direction => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: direction === "left" ? -200 : 200,
        behavior: "smooth",
      })
    }
  }

  return (
    <div className={`c-padding ${styles.serviceMainContainer}`}>
      <div className={`container ${styles.serviceContainer}`}>
        <h2 className={`heading-2 ${styles.head}`}>{title}</h2>

        <div className={styles.mainImg}>
          {imageArray.map((item, index) => (
            <div key={index} className={styles.img}>
              <GatsbyImage
                image={item.gatsbyImageData}
                alt={item.title}
                loading="lazy"
                className={`${styles.eventImage}`}
              />
              {/* <img
                src={item.file.url}
                className={styles.eventImage}
                alt={item.title || "Image"}
                loading="lazy"
              /> */}
              <h3 className={`global-spacing-top ${styles.title}`}>
                {item.title}
              </h3>
            </div>
          ))}
        </div>

        <div className={styles.mobileSliderContainer}>
          <div className={styles.mobileSlider} ref={sliderRef}>
            {imageArray.map((item, index) => (
              <div key={index} className={styles.img}>
                <GatsbyImage
                  image={item.gatsbyImageData}
                  alt={item.title}
                  loading="lazy"
                  className={`${styles.eventImage}`}
                />
                {/* <img
                  src={item.file.url}
                  className={styles.eventImage}
                  alt={item.title || "Image"}
                  loading="lazy"
                /> */}
                <div className={styles.titleMobile}>{item.title}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default EventOurServices
